import React, { useEffect, useState } from "react";

export default function TableOfContents({ containerSelector }) {
  const [headings, setHeadings] = useState([]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const collect = () => {
      const container = document.querySelector(containerSelector);
      if (!container) return false;
      const nodes = Array.from(container.querySelectorAll("h2[id], h3[id]"));
      if (nodes.length === 0) return false;
      setHeadings(
        nodes.map((n) => ({
          id: n.id,
          text: n.textContent.replace(/#$/, "").trim(),
          level: n.tagName,
        }))
      );
      return true;
    };
    if (collect()) return;
    const t = setTimeout(collect, 60);
    return () => clearTimeout(t);
  }, [containerSelector]);

  useEffect(() => {
    if (headings.length === 0) return;
    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActiveId(visible[0].target.id);
      },
      { rootMargin: "-96px 0px -70% 0px", threshold: 0 }
    );
    headings.forEach((h) => {
      const el = document.getElementById(h.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [headings]);

  if (headings.length === 0) return null;

  return (
    <nav aria-label="On this page" className="border-l-2 border-[#D4D4D4] pl-4">
      <p className="font-arcade text-base text-[#15803D] uppercase tracking-wide mb-3">
        &gt; ON THIS PAGE
      </p>
      <ul className="space-y-1.5">
        {headings.map((h) => (
          <li key={h.id} className={h.level === "H3" ? "pl-3" : ""}>
            <a
              href={`#${h.id}`}
              className={`font-terminal text-xs leading-snug block transition-colors py-0.5 ${
                activeId === h.id
                  ? "text-[#15803D] font-bold border-l-2 border-[#15803D] -ml-[18px] pl-4"
                  : "text-[#0A0A0A]/55 hover:text-[#15803D]"
              }`}
            >
              {h.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
